var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'video-panel-' + _vm.playWnd,style:(_vm.videoSize)},[_c('div',{staticClass:"video-content",attrs:{"id":_vm.playWnd}})])}
var staticRenderFns = []

export { render, staticRenderFns }